// extracted by mini-css-extract-plugin
export default {"perfilUsuario":"Perfil_perfilUsuario__Y4xZr","actionUser":"Perfil_actionUser__lYj5x","perfilAccion":"Perfil_perfilAccion__G9R7x","actionUserCenter":"Perfil_actionUserCenter__dGknj"};